import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { GlobalProductService } from 'src/app/services/global-product.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-linked-products-dialog',
  templateUrl: './linked-products-dialog.component.html',
  styleUrls: ['./linked-products-dialog.component.scss']
})
export class LinkedProductsDialogComponent implements OnInit {

  @Input() globalProduct: any = null;

  linkedProducts: any[] = [];
  linkedTotal = 0;
  loading = false;

  constructor(
    private dialogRef: NbDialogRef<LinkedProductsDialogComponent>,
    private globalProductService: GlobalProductService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.globalProduct?._id) {
      this.loadLinkedProducts();
    }
  }

  loadLinkedProducts(): void {
    this.loading = true;
    this.globalProductService.getLinkedProducts(this.globalProduct._id).subscribe({
      next: (res: any) => {
        this.linkedProducts = res?.response?.data?.products || res?.data?.products || res?.data || [];
        this.linkedTotal = res?.response?.data?.total || 0;
        this.loading = false;
      },
      error: (err: any) => {
        this.toastr.error(err?.error?.response?.message || 'Failed to load linked products');
        this.loading = false;
      }
    });
  }

  getLockedFieldsCount(product: any): number {
    if (!product.fieldLocks) return 0;
    return Object.values(product.fieldLocks).filter((v) => v === true).length;
  }

  close(): void {
    this.dialogRef.close();
  }
}
